export const ADMIN_EMAILS = [
  "cjfrancisf@gmail.com",
  "bartholomewscapula@gmail.com",
];

export const isAdminEmail = (email = "") => {
  return ADMIN_EMAILS.includes(String(email || "").trim().toLowerCase());
};
